import Product from './Product/Product';


const ConfigurationConfig = {
    settings: {
      layout: {},
    },
    routes: [
      {
        path: 'configuration',
        element: <Product />,
      }
    ],
  };
  
  export default ConfigurationConfig;
